var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopy1 = function SvgCopy1(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 18,
    viewBox: "0 0 18 18",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.034 15H4.923c-.51 0-1-.204-1.36-.565A1.93 1.93 0 0 1 3 13.07V1.93c0-.512.203-1.002.563-1.364A1.92 1.92 0 0 1 4.923 0h7.41a2.34 2.34 0 0 1 1.71.695l3.264 3.274A2.35 2.35 0 0 1 18 5.683v7.388a1.93 1.93 0 0 1-1.217 1.794c-.238.095-.493.14-.75.134M4.923 1.285a.65.65 0 0 0-.641.643V13.07a.65.65 0 0 0 .641.643h11.11a.65.65 0 0 0 .642-.643v-7.43a1.07 1.07 0 0 0-.316-.764l-3.265-3.274a1.08 1.08 0 0 0-.761-.317z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.75 10.5h-8a.75.75 0 1 1 0-1.5h8a.75.75 0 1 1 0 1.5M10.75 6.5h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 1 1 0 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.795 18h10.37a1.79 1.79 0 0 0 1.695-1.102c.092-.221.14-.459.14-.698V15h-1.236v1.2a.61.61 0 0 1-.599.6H1.795a.606.606 0 0 1-.598-.6V5.8a.61.61 0 0 1 .598-.6H3V4H1.795c-.476 0-.933.19-1.27.527A1.8 1.8 0 0 0 0 5.8v10.4c0 .477.19.935.526 1.272.336.338.793.528 1.269.528"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopy1);
export default ForwardRef;